<template>
  <el-form ref="form"
           :model="formData"
           label-width="150px">
    <el-row>
      <el-col :span="7">
        <el-form-item label="整数，小数输入示例:">
          <custom-input v-model="formData.title"
                        maxlength="6"
                        precision="2"
                        placeholder="请输入"></custom-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      formData: { title: '' }
    }
  },
  created() {
  },
}
</script>